import { createSlice } from '@reduxjs/toolkit'

export interface IMatchEngineViewState {
    shareMatchListModal: boolean
    visibleSendEmailModal: boolean
    visibleTextNoteModal: boolean
    sharedListId: string
    subRecordId: string
    email: string
    shareMatchListId: string | string[]
    editMatchListModal: boolean
    generateLinkMatchListModal: boolean
    successMatchEngineModal: boolean
}

const initialState: IMatchEngineViewState = {
    shareMatchListModal: false,
    visibleSendEmailModal: false,
    visibleTextNoteModal: false,
    sharedListId: '',
    subRecordId: '',
    email: '',
    shareMatchListId: '',
    editMatchListModal: false,
    generateLinkMatchListModal: false,
    successMatchEngineModal: false
}

const matchListViewSlice = createSlice({
    name: 'match_lists/view',
    initialState,
    reducers: {
        setShareMatchListModal(state, action) {
            state.shareMatchListModal = action.payload.visible
            state.shareMatchListId = action.payload.matchListId
        },
        setTextNoteModal(state, action) {
            state.visibleTextNoteModal = action.payload.visible
            state.sharedListId = action.payload.sharedListId
            state.subRecordId = action.payload.subRecordId
        },
        setSendEmailModal(state, action) {
            state.visibleSendEmailModal = action.payload.visible
            state.email = action.payload.email
        },
        setEditMatchListModal(state, action) {
            state.editMatchListModal = action.payload
        },
        setGenerateLinkMatchListModal(state, action) {
            state.generateLinkMatchListModal = action.payload
        },
        setSuccessMatchEngineModal(state, action) {
            state.successMatchEngineModal = action.payload
        }
    }
})

export const matchListViewActions = matchListViewSlice.actions
export default matchListViewSlice.reducer
